import { Controller } from "@hotwired/stimulus"

// Import TinyMCE
import tinymce from 'tinymce/tinymce'
import 'tinymce/models/dom'

// A theme is also required
import 'tinymce/themes/silver';

// Default icons are required
import 'tinymce/icons/default';

import "tinymce/skins/ui/oxide/skin";
import "tinymce/skins/ui/oxide/content";
import "tinymce/skins/content/default/content";

// Any plugins you want to use has to be imported
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/emoticons';

import emojisURL from 'tinymce/plugins/emoticons/js/emojis.js?url';

export default class extends Controller {
  static values = {
    submitOnEnter: Boolean
  }

  connect () {
    console.log(this.submitOnEnterValue);
    this.tinymce = tinymce.init({
      target: this.element,
      license_key: 'gpl',
      relative_urls: false,
      emoticons_database_url: emojisURL,
      menubar: false,
      height: 250,
      plugins: 'autolink emoticons wordcount visualblocks',
      toolbar: 'bold italic underline | emoticons',
      visualblocks_default_state: true,
      end_container_on_empty_block: true,
      paste_as_text: true,
      valid_elements : "a[href|target|title],p,strong/b,u,i/em,br",

      setup: (editor) => {
        if (this.submitOnEnterValue) {
          editor.on('keydown', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              editor.save() // Push content to textarea
              const form = this.element.closest("form")
              if (form) form.requestSubmit()
            }
          })
        }
      }
    })
  }

  disconnect () {
    tinymce.remove()
  }
}
